import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Import modules
const modules = {}
const ctx = require.context('src/store', false, /\.js$/)
ctx.keys().forEach(key => {
  const name = key.replace('./', '').replace('.js', '')
  modules[name] = ctx(key)
})

export default new Vuex.Store({
  modules,
  state: {
    /**
     * Global data
     * @type {Object}
     */
    data: loadData(),

    /**
     * Open the authenticator
     * @type {Boolean}
     */
    authenticate: false,

    /**
     * Current page info
     * @type {Object}
     */
    currentPage: {
      path: '',
      excerpt: '',
      body: '',
      attributes: {
        title: ''
      }
    }
  },

  actions: {
    /**
     * Open the authenticator
     * @param  {Object} context
     * @param  {Object} opts
     */
    authenticate: function (context, opts) {
      context.commit('SET_AUTHENTICATE', opts)
    },

    /**
     * Set data for the current page
     * @param  {Object} context
     * @param  {Object} data
     */
    setCurrentPage: function (context, data) {
      context.dispatch('clearCurrentPage')
      context.commit('SET_CURRENT_PAGE', data)
    },

    /**
     * Clear (reset) the current page data
     * @param  {Object} context
     * @param  {Object} data
     */
    clearCurrentPage: function (context, data) {
      context.commit('SET_CURRENT_PAGE', {
        path: '',
        excerpt: '',
        body: '',
        attributes: {
          title: ''
        }
      })
    }
  },

  mutations: {
    SET_AUTHENTICATE: function (state, opts) {
      state.authenticate = opts
    },

    SET_CURRENT_PAGE: function (state, data) {
      state.currentPage = data
    }
  }
})

/**
 * Global data loader
 * - Loads all yaml or json files in src/data/
 * @return {Object}
 */
function loadData () {
  const data = {}
  const req = require.context('data')

  req.keys().forEach(function (key) {
    const name = key.split('/').pop().split('.').shift()
    data[name] = req(key)
  })

  return data
}



// WEBPACK FOOTER //
// ./app/src/store/index.js